// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__YVOtd","gradient":"button_gradient__aflLE","pink":"button_pink__1Yc0+","white":"button_white__WIEMs","blue":"button_blue__ytreZ"};